import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { AvailableIntegrationsListQuery, AvailableIntegrationsListQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(AvailableIntegrationsListQuery)
@Wrapper(AvailableIntegrationsListQueryHandlerBase)
export class AvailableIntegrationsListQueryHandler {
    public constructor(
        http: Http
    ) { }
}
